// removed by extract-text-webpack-plugin
module.exports = {"menuText":"#fff","menuActiveText":"#ED6C00","subMenuActiveText":"#ED6C00","menuBg":"#164934","menuHover":"#3c7352","subMenuBg":"#265e47","subMenuHover":"#3c7352","sideBarWidth":"240px"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/index.scss
// module id = yh13
// module chunks = 164